"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnrollmentStepsApi = void 0;
const generateEnrollment_1 = require("./generateEnrollment");
class EnrollmentStepsApi {
    async startEnrollment() {
        return Promise.resolve(generateEnrollment_1.generateNewEnrollment());
    }
    confirmEligibility(requestParameters, mockBase) {
        const enrollment = generateEnrollment_1.generateEnrollment({
            ...(mockBase || {}),
            eligibility: requestParameters.preEligibilityStep,
        });
        return Promise.resolve(enrollment);
    }
    reportCitizenship(requestParameters, mockBase) {
        const enrollment = generateEnrollment_1.generateEnrollment({
            ...(mockBase || {}),
            citizenship: requestParameters.preCitizenshipStep,
        });
        return Promise.resolve(enrollment);
    }
    chooseDocuments(requestParameters, mockBase) {
        const enrollment = generateEnrollment_1.generateEnrollment({
            ...(mockBase || {}),
            documentCheck: requestParameters.preDocumentCheckStep,
        });
        return Promise.resolve(enrollment);
    }
    biographicInfo(requestParameters, mockBase) {
        const enrollment = generateEnrollment_1.generateEnrollment({
            ...(mockBase || {}),
            biographicInfo: requestParameters.preBiographicInfoStep,
        });
        return Promise.resolve(enrollment);
    }
    provideContact(requestParameters, mockBase) {
        const enrollment = generateEnrollment_1.generateEnrollment({
            ...(mockBase || {}),
            contact: requestParameters.preContactStep,
        });
        return Promise.resolve(enrollment);
    }
    giveIdentityHints(requestParameters, mockBase) {
        const enrollment = generateEnrollment_1.generateEnrollment({
            ...(mockBase || {}),
            identityHints: requestParameters.preIdentityStep,
        });
        return Promise.resolve(enrollment);
    }
    provideAttributes(requestParameters, mockBase) {
        const enrollment = generateEnrollment_1.generateEnrollment({
            ...(mockBase || {}),
            attributes: requestParameters.preAttributesStep,
        });
        return Promise.resolve(enrollment);
    }
    provideAddresses(requestParameters, mockBase) {
        const enrollment = generateEnrollment_1.generateEnrollment({
            ...(mockBase || {}),
            addresses: requestParameters.preAddressesStep,
        });
        return Promise.resolve(enrollment);
    }
    answerLegalQuestionnaire(requestParameters, mockBase) {
        const enrollment = generateEnrollment_1.generateEnrollment({
            ...(mockBase || {}),
            legal: requestParameters.preLegalQuestionnaireStep,
        });
        return Promise.resolve(enrollment);
    }
    finishDocumentUpload(requestParameters, mockBase) {
        const enrollment = generateEnrollment_1.generateEnrollment({
            ...(mockBase || {}),
            documents: {
                ...requestParameters.preDocumentUploadStepCommand,
                uploadedFiles: [],
            },
        });
        return Promise.resolve(enrollment);
    }
    finalizePreEnrollment(requestParameters, mockBase) {
        const enrollment = generateEnrollment_1.generateEnrollment({
            ...(mockBase || {}),
            finalized: {
                enrollmentLocationId: requestParameters.preFinalizeStepCommand.enrollmentLocationId,
            },
        });
        return Promise.resolve(enrollment);
    }
    selectPlan(requestParameters, mockBase) {
        var _a;
        const enrollment = generateEnrollment_1.generateEnrollment({
            ...(mockBase || {}),
            planSelection: {
                services: [],
                price: 0,
                description: '',
                key: ((_a = requestParameters.planSelectionCommand) === null || _a === void 0 ? void 0 : _a.plan) || '',
            },
        });
        return Promise.resolve(enrollment);
    }
    uploadDocument(requestParameters) {
        return Promise.resolve();
    }
}
exports.EnrollmentStepsApi = EnrollmentStepsApi;
//# sourceMappingURL=EnrollmentStepsApi.js.map